import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { DIBELS8, R3D, BURST, R3DSPANISH, IDEL2 } from '../../../constants/applications';
import { PERIOD } from '../../../constants/enrollment';
import { studentType } from '../../../constants/prop-types';
import TRCDetails from '../trc-details/TRCDetails';
import { getCompositeScore } from '../composite-score/CompositeScore';
import { useAppContext } from '../../../common/contexts/AppContext';
import { useTRCAppContext } from '../../../common/contexts/TRCAppContext';
import { useAppConfigContext } from '../../../common/contexts/AppConfigContext';
import { useFeatureToggleContext } from '../../../common/contexts/FeatureToggleContext';

const StudentShortSummary = React.forwardRef(
    ({ student, applicationsForRender, expandable }, ref) => {
        const { bmWindow } = useAppContext();
        const trcApp = useTRCAppContext();
        const { isLecturaLicensed, isSecureAssessmentsEnabled } = useAppConfigContext();
        const {
            isLecturaCompositeScoreEnabled,
            hideDidels8WithIntervention,
        } = useFeatureToggleContext();

        const getTRCDetails = () => {
            if (bmWindow.period === PERIOD.SUMMER) {
                return <div />;
            }
            const trcDetails = student.appStatuses[trcApp][bmWindow.period];

            return <TRCDetails {...trcDetails} />;
        };

        const getBurstStatus = () => {
            if (bmWindow.period === PERIOD.SUMMER) {
                return '';
            }
            const isPlacementTestComplete =
                student.appStatuses.burst[bmWindow.period].isPlacementTestComplete;

            return isPlacementTestComplete !== null && isPlacementTestComplete ? 'Ready' : '';
        };

        const showCompositeScoreForSecureAssessments = !(
            isSecureAssessmentsEnabled && hideDidels8WithIntervention
        );

        return (
            <div ref={ref} className='dashboard-student-short-summary'>
                {applicationsForRender.map(appName => (
                    <Fragment key={appName}>
                        {appName === DIBELS8 && showCompositeScoreForSecureAssessments && (
                            <div className='dashboard-short-summary-column'>
                                {getCompositeScore(DIBELS8, student, bmWindow.period)}
                            </div>
                        )}
                        {appName === IDEL2 &&
                            isLecturaLicensed &&
                            isLecturaCompositeScoreEnabled &&
                            showCompositeScoreForSecureAssessments && (
                                <div className='dashboard-short-summary-column'>
                                    {getCompositeScore(IDEL2, student, bmWindow.period)}
                                </div>
                            )}

                        {(appName === R3D || appName === R3DSPANISH) && (
                            <div className='dashboard-short-summary-column dashboard-trc'>{getTRCDetails()}</div>
                        )}

                        {appName === BURST && (
                            <div className='dashboard-short-summary-column dashboard-mclass-intervention'>
                                {getBurstStatus()}
                            </div>
                        )}
                    </Fragment>
                ))}

                <div className='dashboard-short-summary-column dashboard-name'>
                    {`${student.firstName} ${student.lastName}`}
                </div>

                {expandable && <div className='dashboard-arrow' />}
            </div>
        );
    },
);

StudentShortSummary.propTypes = {
    student: studentType.isRequired,
    expandable: PropTypes.bool,
    applicationsForRender: PropTypes.arrayOf(PropTypes.string).isRequired,
};

StudentShortSummary.defaultProps = {
    expandable: false,
};

export default StudentShortSummary;
